import { makeAutoObservable } from "mobx";

export class Calibra {
    Id: number;
    ArticleNumber: number;
    Manufacturer: string;
    ProductType: string;
    SerialNumber: string;
    CalibrationDepot: string;
    TechnicianRegistrationNumber: number;
    CalibrationDateUtc: Date;
    CalibrationTypeId: number;
    IsDeleted: boolean;
    QRCode: string;
    StatusId: number;
    ArticleNumberString: string;
    ManufacturerId: number;
    CalibrationDepotId:string;
    constructor() {
        makeAutoObservable(this);
        this.Id = 0;
        this.ArticleNumber = null;
        this.Manufacturer = "";
        this.ProductType = "";
        this.SerialNumber = null;
        this.CalibrationDepot = null;
        this.TechnicianRegistrationNumber = null;
        this.CalibrationDateUtc = null;
        this.CalibrationTypeId = 0;
        this.IsDeleted = null;
        this.QRCode = null;
        this.StatusId = 0;
        this.ArticleNumberString = "";
        this.ManufacturerId = 0;
        this.CalibrationDepotId=null;
    }
}